var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ELEMENT } from './ELEMENT';
var IMG = /** @class */ (function (_super) {
    __extends(IMG, _super);
    function IMG(props) {
        var _this = 
        // 'img' в нижнем регистре чтобы не попасть под обфускатор
        _super.call(this, 'img', props) || this;
        if (props.onError) {
            _this.el.addEventListener('error', function () {
                props.onError();
            });
        }
        return _this;
    }
    Object.defineProperty(IMG.prototype, "src", {
        set: function (src) {
            ;
            this.valueOf().src = src;
        },
        enumerable: false,
        configurable: true
    });
    return IMG;
}(ELEMENT));
export { IMG };
